<template>
  <b-overlay :show="removeItem.loading && removeItem.itemId === petId" rounded="sm" variant="white">
    <div class="wallet-card-product product pr-1">
      <b-row no-gutters align-v="center">
        <b-col cols="auto" class="pl-2">
          <b-img :src="require('@/assets/paw_card.png')" class="d-none d-md-block" width="90px" height="90px" alt="" />
          <b-img :src="require('@/assets/paw_card.png')" class="d-block d-md-none" width="60px" height="60px" alt="" />
        </b-col>
        <b-col class="ml-2">
          <h4 class="m-0 product-name mb-1 d-flex align-items-center">
            {{ $t('views.basket.petIdentificationCard') }}
          </h4>
          <div v-if="!walletCardComplete">
            <h5 class="m-0 text-danger">{{ $t('views.basket.walletCardMissingInfo') }}</h5>
            <b-link @click="finishWalletCard()" v-if="petName">
              <h5 class="m-0 text-primary">
                <u>{{ $t('views.basket.walletCardFinishPet', { petName: petName }) }}</u>
              </h5>
            </b-link>
            <b-link @click="assignWalletCard()" v-else>
              <h5 class="m-0 text-primary">
                <u>{{ $t('views.basket.walletCardAssignPet') }}</u>
              </h5>
            </b-link>
          </div>
        </b-col>
        <b-col cols="auto" class="d-flex align-items-center mt-2 mt-xs-0">
          <b-button v-if="remove" variant="link" class="m-0 p-0 text-right" block @click="removeWalletCard(petId)">remove</b-button>
        </b-col>
      </b-row>
    </div>
    <div ref="confirmationModal"></div>
  </b-overlay>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import { DpConfirmationModal } from '@docupet/component-library';

export default {
  name: 'ConfigureWalletCard',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    DpConfirmationModal,
  },
  props: {
    petId: {
      type: String,
      required: false,
    },
    petName: {
      type: String,
      required: false,
    },
    remove: {
      type: Boolean,
      required: false,
      default: false,
    },
    walletCardComplete: {
      type: Boolean,
      required: false,
      default: true,
    },
    orderItemBundle: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapState({
      orderId: (state) => state.orderId,
      order: (state) => state.order.order,
      locale: (state) => state.locale,
      removeItem: (state) => state.order.removeItem,
    }),
    walletCardSelectionLink() {
      const baseURL = `${window.BASE_URL}/${this.locale}/${this.orderId ? `order/${this.orderId}/` : ''}store`;
      return `${baseURL}/wallet-cards/pet/${this.petId}/style/all?redirect_path=basket`;
    },
  },
  methods: {
    async removeWalletCard(petId, confirm = false) {
      if (this.orderItemBundle !== null) {
        if (confirm === false) {
          this.showRemoveBundleItemConfirmationModal();
          return;
        }
        this.$emit('remove-bundle');
      }
      await this.removeIncompleteWalletCardItems();
      await this.$store.dispatch('order/removeWalletCard', {
        orderId: this.order?.id || this.orderId,
        petId: petId,
        optInForWalletCard: false,
      });
    },
    async finishWalletCard() {
      await this.removeIncompleteWalletCardItems();
      window.location.href = this.walletCardSelectionLink;
    },
    async assignWalletCard() {
      window.location.href = `${window.BASE_URL}/${this.locale}/${this.orderId ? `order/${this.orderId}/` : ''}store`;
    },
    async removeIncompleteWalletCardItems() {
      // TODO: Remove this method once we have a better way to handle incomplete wallet card items in the backend
      const incompleteWalletCards = this.order?.items?.filter(
        (item) =>
          item?.group?.pet?.id === this.petId && item.product?.type === 'WALLET_CARD' && false === item.isCompleted && null === item.parent
      );
      await incompleteWalletCards?.map(
        async (item) =>
          await this.$store.dispatch('order/removeItem', {
            orderId: this.orderId,
            itemId: item.id,
          })
      );
    },
    showRemoveBundleItemConfirmationModal() {
      const modalContainer = this.$refs.confirmationModal;

      if (modalContainer.childNodes.length) {
        modalContainer.childNodes.forEach((node) => node.remove());
      }

      new Vue({
        render: (h) => {
          let messageText = this.$t('components.removeBundleItemConfirmation.messageNoPet')

          if (this.petName) {
            messageText = this.$t('components.removeBundleItemConfirmation.message', {
              petName: this.petName,
            })
          }

          return h(DpConfirmationModal, {
            props: {
              id: `remove-item-confirmation-${this.petId}`,
              title: this.$t('components.removeBundleItemConfirmation.title'),
              message: messageText,
              cancelButtonText: this.$t('components.removeBundleItemConfirmation.cancelButtonText'),
              confirmButtonText: this.$t('components.removeBundleItemConfirmation.confirmButtonText'),
              show: true,
            },
            on: {
              confirm: () => this.removeWalletCard(this.petId, true),
              cancel: () => modalContainer.childNodes.forEach((node) => node.remove()),
            },
          });
        },
      }).$mount(modalContainer);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/main';
$grid-breakpoints: (
  xs: 450px,
);
.product {
  h5 {
    font-size: 0.9rem;
  }
  @include media-breakpoint-up(xs) {
    h4 {
      font-size: $h3-font-size;
    }
    h5 {
      font-size: $h4-font-size;
    }
    .mt-xs-0 {
      margin-top: 0 !important;
    }
  }
  .product-name {
    color: $dp-gray-7;

    .bundle-badge {
      font-size: 0.75rem;
    }
  }
}
</style>
